import React from "react";
import EditIcon from "../../../assets/icons/edit-icon.png";
import Table from "../../../components/Table/Table.jsx";

const AppointmentsList = ({ appointments, onEditClick }) => {
  if (!appointments || appointments.length === 0) {
    return <p>No appointments found.</p>;
  }
  const columns = [
    { header: "Reference", accessor: "refferenceCode" },
    { header: "Date", render: (row) => new Date(row.date).toLocaleString() },
    { header: "Start Time", accessor: "startTime" },
    { header: "End Time", accessor: "endTime" },
    { header: "Customer", accessor: "client" },
    { header: "Staff", accessor: "staffName" },
    {
      header: "Services",
      render: (row) => row.services.map((s) => s.name).join(", "),
    },
    { header: "Status", accessor: "status" },
    {
      header: "Actions",
      render: (row, { onEdit }) => (
        <>
          <button className="btn btn-edit" onClick={() => onEdit(row)}>
            <img src={EditIcon} />
          </button>
        </>
      ),
    },
  ];
  return (
    <Table
      columns={columns}
      data={appointments}
      onEdit={onEditClick}
      title={"Appointments List"}
    />
  );
};

export default AppointmentsList;
